import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTranslation } from "react-i18next";

function SSMLMobileViewBanner({ open = true }): JSX.Element {
  const { t } = useTranslation();

  return (
    <Box
      display={open ? { xs: "flex", sm: "none" } : "none"}
      bgcolor="info.light"
      className="mobile-view-banner"
      sx={{
        width: "100%",
        p: 2,
        my: 2,
      }}
    >
      <InfoOutlinedIcon fontSize="medium" />
      <Typography variant="body2" sx={{ pl: 1 }}>
        {t("homepage.mobileViewBannerText")}
      </Typography>
    </Box>
  );
}

export default SSMLMobileViewBanner;
